// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"4ef114ec","91":"a970bf88","392":"9881ddba","564":"bf32a4d0","620":"f8efff5d","776":"81dba0c1"}[chunkId] + ".chunk.js";
};